import { OrganizationMembership } from '../../models/OrganizationMembership';
import { Family, emptyFamily } from 'common/api/crm/models/Family';
import { Organization, emptyOrganization } from '../../organization/enrollment/models';

export type DefaultOrganization = Organization & Pick<OrganizationMembership, 'isCoordinator'>;
export interface HomeDetailsResponse {
    profile: Family;
    selectedOrgId: string | null;
    defaultOrganization: DefaultOrganization | null;
    organizations: Record<string, OrganizationMembership>;
}

export const emptyHomeDetailsResponse: HomeDetailsResponse = {
    profile: emptyFamily,
    selectedOrgId: null,
    defaultOrganization: { ...emptyOrganization, isCoordinator: false },
    organizations: {},
};
